import React from "react";

import { Box, Card, CardContent, Typography } from "@material-ui/core";
import BarChartRoundedIcon from "@material-ui/icons/BarChartRounded";
import NoDataCard from "./NoDataCard";
import CardSkeleton from "./CardSkeleton";


const colorPalette = [
  { color: "#2563EB", gradient: "linear-gradient(90deg, #2563EB, #5B8DEF)" },
  { color: "#F97316", gradient: "linear-gradient(90deg, #F97316, #FB923C)" },
  { color: "#10B981", gradient: "linear-gradient(90deg, #10B981, #34D399)" },
  { color: "#F59E0B", gradient: "linear-gradient(90deg, #F59E0B, #FBBF24)" },
  { color: "#9333EA", gradient: "linear-gradient(90deg, #9333EA, #C084FC)" },
];

const maxValue = (data = []) => Math.max(...(data || []).map((item) => item?.count || 0));


const CardComp = ({ cardName, cardData, loading }) => {
  const totalProjects = (cardData || []).reduce(
    (total, item) => total + (item?.count || 0),
    0
  );

  if (loading) {
    return <CardSkeleton height={310} />;
  }

  if (!cardData || !cardData.length) {
    return <NoDataCard title={cardName} />;
  }

  return (
    <Card style={{ border: "1px solid #E5E7EB", borderRadius: 10, backgroundColor: "#FFFFFF", overflow: "hidden", boxShadow: "0 4px 18px rgba(15, 23, 42, 0.05)" }} elevation={1}>
      {/* HEADER */}
      <Box style={{ padding: "14px 18px", borderBottom: "1px solid #EEF0F4", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Box style={{ display: "flex", alignItems: "center" }}>
          <Box style={{ width: 20, height: 20, borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", background: "linear-gradient(135deg, #EFF6FF 0%, #DBEAFE 100%)", color: "#2563EB", marginRight: 8 }}>
            <BarChartRoundedIcon fontSize="small" />
          </Box>

          <Box>
            <Typography style={{ fontSize: 16, fontWeight: 800, color: "#172033", lineHeight: 1.2 }}>
              {cardName}
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* CHART */}
      <CardContent style={{ padding: "5px 20px 10px", height: "240px", overflow: "auto" }}>
        {!!cardData && (cardData || []).map((item, index) => {
          const width = `${((item?.count || 0) / maxValue(cardData)) * 100}%`;
          const isLastRow = index === (cardData || []).length - 1;
          const { color, gradient } = colorPalette[index % colorPalette.length] || {};

          return (
            <Box key={item?.label} style={{ display: "grid", gridTemplateColumns: "140px minmax(0, 1fr) 45px", alignItems: "center", columnGap: 1, minHeight: 45, borderBottom: isLastRow ? "none" : "1px solid #EEF0F4" }}>
              {/* LABEL */}
              <Typography title={item?.label} style={{ fontSize: 14, fontWeight: 500, color: "#526078", whiteSpace: "nowrap" }}>
                {item?.label?.length > 15
                  ? `${item.label.slice(0, 15)}...`
                  : item?.label}
              </Typography>

              {/* BAR */}
              <Box style={{ width: "100%", height: 25, borderRadius: 7, backgroundColor: "#F1F3F7", overflow: "hidden", position: "relative" }}>
                <Box style={{ height: "100%", minWidth: 48, borderRadius: 7, display: "flex", alignItems: "center", padding: "0 14px", boxSizing: "border-box", width, background: gradient, boxShadow: `0 3px 10px ${color}35` }}>
                  <Typography style={{ color: "#FFFFFF", fontSize: 15, fontWeight: 700, lineHeight: 1 }}>
                    {item?.count || 0}
                  </Typography>
                </Box>
              </Box>

              {/* COUNT */}
              <Typography style={{ textAlign: "right", fontSize: 17, fontWeight: 700, color: color }}>
                {item?.count || 0}
              </Typography>
            </Box>
          );
        })}
      </CardContent>
    </Card>
  );
};

export default CardComp;
